import React from 'react';
import './AboutSection.css';
/* DİL SİSTEMİ İMPORTU */
import { useLanguage } from '../../context/LanguageContext';

const AboutSection = () => {
  /* Dil fonksiyonlarını çekiyoruz kanka */
  const { t, lang } = useLanguage();

  // Vurgu noktalarını dile göre (TR, EN, AR) dinamik yapıyoruz
  const highlights = lang === 'TR' ? [
    "Since 2006",
    "Yaklaşık 20 Yıl Tecrübe",
    "Ar-Ge ve Laboratuvar",
    "İhracat Vizyonu"
  ] : lang === 'AR' ? [
    "منذ عام 2006",
    "خبرة تقارب 20 عاماً",
    "البحث والتطوير والمختبر",
    "رؤية التصدير"
  ] : [
    "Since 2006",
    "Nearly 20 Years Experience",
    "R&D and Laboratory",
    "Export Vision"
  ];

  return (
    /* KANKA: Navbar'dan yönlendirme için ID buraya eklendi */
    <section id="hakkimizda-bolumu" className="about-modern-section">
      <div className="about-container">
        
        {/* Sol İçerik Alanı */}
        <div className="about-text-content">
          <span className="about-badge">{t('aboutSection.badge')}</span>
          <h2 className="about-title">{t('aboutSection.title')}</h2>
          
          <div className="about-description">
            {/* t() fonksiyonu translations.js içindeki AR bölümünden çeker kanka */}
            <p>{t('aboutSection.p1')}</p>
            <p>{t('aboutSection.p2')}</p>
          </div>

          <div className="about-highlights-grid">
            {highlights.map((item, index) => (
              <div key={index} className="highlight-item">
                {item}
              </div>
            ))}
          </div>
        </div>

        {/* Sağ Görsel/Renk Alanı */}
        <div className="about-visual-content">
          <div className="about-card-placeholder">
            <p>{t('aboutSection.cardText')}</p>
          </div>
          <div className="about-glow-effect"></div>
        </div>

      </div>
    </section>
  );
};

export default AboutSection;